const BASE_URL = "https://api.voleybolalemi.com/api";

export const ENDPOINTS = {
    // Auth
    AUTH: {
        LOGIN: `${BASE_URL}/Auth/Login`,
    },


    //  Students
    STUDENTS: {
        CREATE: `${BASE_URL}/Students`,
        UPDATE: `${BASE_URL}/Students`,
        DELETE: `${BASE_URL}/Students/:id`,
        GET_BY_ID: `${BASE_URL}/Students/:id`,
        GET_LIST: `${BASE_URL}/Students`,
        GET_LIST_BY_GROUP: `${BASE_URL}/Students/by-group`,
        GET_LIST_BY_AGE_GROUP: `${BASE_URL}/Students/by-age-group`,
        UPDATE_PHOTO: `${BASE_URL}/Students/:id/photo`,

    },

    //  Branches
    BRANCHES: {
        CREATE: `${BASE_URL}/Branches`,
        UPDATE: `${BASE_URL}/Branches`,
        DELETE: `${BASE_URL}/Branches/:id`,
        GET_BY_ID: `${BASE_URL}/Branches/:id`,
        GET_LIST: `${BASE_URL}/Branches`,
    },

    //  Groups
    GROUPS: {
        CREATE: `${BASE_URL}/Groups`,
        UPDATE: `${BASE_URL}/Groups`,
        DELETE: `${BASE_URL}/Groups/:id`,
        GET_BY_ID: `${BASE_URL}/Groups/:id`,
        GET_LIST: `${BASE_URL}/Groups`,
    },
    //  Groups
    AGE_GROUPS: {
        CREATE: `${BASE_URL}/AgeGroups`,
        UPDATE: `${BASE_URL}/AgeGroups`,
        DELETE: `${BASE_URL}/AgeGroups/:id`,
        GET_BY_ID: `${BASE_URL}/AgeGroups/:id`,
        GET_LIST: `${BASE_URL}/AgeGroups`,
    },

    //  Trainers
    TRAINERS: {
        CREATE: `${BASE_URL}/Trainers`,
        UPDATE: `${BASE_URL}/Trainers`,
        DELETE: `${BASE_URL}/Trainers/:id`,
        GET_BY_ID: `${BASE_URL}/Trainers/:id`,
        GET_LIST: `${BASE_URL}/Trainers`,
    },
    //  Achievements
    ACHIEVEMENTS: {
        CREATE: `${BASE_URL}/StudentAchievements`,
        UPDATE: `${BASE_URL}/StudentAchievements`,
        DELETE: `${BASE_URL}/StudentAchievements/:id`,
        GET_BY_ID: `${BASE_URL}/StudentAchievements/by-student/:id`,
        GET_LIST: `${BASE_URL}/StudentAchievements`,
        ASSIGN_BULK: `${BASE_URL}/StudentAchievements/assign-bulk`,
    },

    //  Packages
    PACKAGES: {
        GET_LIST: `${BASE_URL}/Packages`,
        UPDATE: `${BASE_URL}/Packages`,
        ADD_PAYMENT: `${BASE_URL}/Packages/add-payment`,
        ASSIGN_PACKAGE_TO_STUDENT: `${BASE_URL}/Packages/assign-to-student`,
        ASSIGN_BULK: `${BASE_URL}/Packages/assign-bulk`,
        DELETE: `${BASE_URL}/PackageStudents/:id`,
    },
    //  Package Plans
    PACKAGE_PLANS: {
        CREATE: `${BASE_URL}/PackagePlans`,
        UPDATE: `${BASE_URL}/PackagePlans`,
        DELETE: `${BASE_URL}/PackagePlans/:id`,
        GET_BY_ID: `${BASE_URL}/PackagePlans/:id`,
        GET_LIST: `${BASE_URL}/PackagePlans`,
    },

    //  Owners
    OWNERS: {
        CREATE: `${BASE_URL}/Owners`,
        UPDATE: `${BASE_URL}/Owners`,
        DELETE: `${BASE_URL}/Owners/:id`,
        GET_BY_ID: `${BASE_URL}/Owners/:id`,
        GET_LIST: `${BASE_URL}/Owners`,
    },



    //  Prices
    PRICES: {
        CREATE: `${BASE_URL}/Prices`,
        UPDATE: `${BASE_URL}/Prices`,
        DELETE: `${BASE_URL}/Prices/:id`,
        GET_BY_ID: `${BASE_URL}/Prices/:id`,
        GET_LIST: `${BASE_URL}/Prices`,
    },

    //  Student Attendances
    STUDENT_ATTENDANCES: {
        CREATE: `${BASE_URL}/StudentAttendances`,
        UPDATE: `${BASE_URL}/StudentAttendances`,
        DELETE: `${BASE_URL}/StudentAttendances/:id`,
        GET_LIST: `${BASE_URL}/StudentAttendances`,
    },

    //  Measurement Fields
    MEASUREMENT_FIELDS: {
        CREATE: `${BASE_URL}/MeasurementFields`,
        UPDATE: `${BASE_URL}/MeasurementFields`,
        DELETE: `${BASE_URL}/MeasurementFields/:id`,
        GET_BY_ID: `${BASE_URL}/MeasurementFields/:id`,
        GET_LIST: `${BASE_URL}/MeasurementFields`,
    },

    //  Measurement Values
    MEASUREMENT_VALUES: {
        CREATE: `${BASE_URL}/MeasurementValues`,
        UPDATE: `${BASE_URL}/MeasurementValues`,
        DELETE: `${BASE_URL}/MeasurementValues/:id`,
        GET_BY_ID: `${BASE_URL}/MeasurementValues/:id`,
        GET_LIST: `${BASE_URL}/MeasurementValues`,
    },

    //  Student Measurements
    STUDENT_MEASUREMENTS: {
        CREATE: `${BASE_URL}/StudentMeasurements`,
        UPDATE: `${BASE_URL}/StudentMeasurements`,
        DELETE: `${BASE_URL}/StudentMeasurements/:id`,
        GET_BY_ID: `${BASE_URL}/StudentMeasurements/:id`,
        GET_LIST: `${BASE_URL}/StudentMeasurements`,
    },

    // Health Check
    HEALTH: {
        CHECK: `${BASE_URL}/HealthCheck`,
    },

    // Reports
    REPORTS: {
        UNPAID_STUDENTS: `${BASE_URL}/Reports/unpaid-students`,
        STUDENT_ATTENDANCE_LIST: `${BASE_URL}/StudentAttendanceReports/list`,
        STUDENT_ATTENDANCE_SUMMARY: `${BASE_URL}/StudentAttendanceReports/summary`,
        STUDENT_PACKAGE_LIST: `${BASE_URL}/StudentPackageReports/list`,
        STUDENT_PACKAGE_SUMMARY: `${BASE_URL}/StudentPackageReports/summary`,
        BIRTHDAY_STUDENTS: `${BASE_URL}/Reports/birthday-students`,
    },

    FINANCE: {
        GET_LIST: `${BASE_URL}/Finance`,
        ADD: `${BASE_URL}/Finance`,
    },

    WP_CONFIG: {
        GET: `${BASE_URL}/WpConfigs`,
        CREATE: `${BASE_URL}/WpConfigs`,
        UPDATE: `${BASE_URL}/WpConfigs/:id`,
    },

    WP: {
        INSTANCE_STATUS: `${BASE_URL}/Wp/instance-status`,
        CREATE_INSTANCE: `${BASE_URL}/Wp/create-instance`,
        SEND_MESSAGE: `${BASE_URL}/Wp/send-message`,
    },

    //  Student Parents (Veliler)
    STUDENT_PARENTS: {
        GET_LIST: `${BASE_URL}/StudentParents`,
        CREATE_PASSWORD: `${BASE_URL}/StudentParents/:parentId/create-password`,
    },

    //  News
    NEWS: {
        CREATE: `${BASE_URL}/News`,
        UPDATE: `${BASE_URL}/News/:id`,
        DELETE: `${BASE_URL}/News/:id`,
        GET_BY_ID: `${BASE_URL}/News/:id`,
        GET_LIST: `${BASE_URL}/News`,
        UPDATE_COVER_IMAGE: `${BASE_URL}/News/:id/cover-image`,
    },



    PLACES: {
        GET_LIST: `${BASE_URL}/Places`,
        CREATE: `${BASE_URL}/Places`,
        UPDATE: `${BASE_URL}/Places/:id`,
        DELETE: `${BASE_URL}/Places/:id`,
    },

    NOTIFICATIONS: {
        SEND: `${BASE_URL}/Notifications/send`,
    },

    PRE_REGISTRATIONS: {
        GET_LIST: `${BASE_URL}/PreRegistrations`,
        CREATE: `${BASE_URL}/PreRegistrations`,
        UPDATE: `${BASE_URL}/PreRegistrations`,
        DELETE: `${BASE_URL}/PreRegistrations/:id`,
    },
};

export default ENDPOINTS;